/**
 * Device ID Utility
 *
 * Generates and manages a unique device identifier for per-device settings.
 * The device ID is stored in localStorage and persists across sessions.
 */

/**
 * Get or create a unique device identifier
 * This ID is used to store per-device preferences in Supabase
 */
export function getDeviceId(): string {
  const DEVICE_ID_KEY = 'nidonote-device-id';

  // Check if we already have a device ID
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    // Generate a new device ID using browser fingerprint + timestamp
    const userAgent = navigator.userAgent;
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 15);

    // Create a simple hash
    const fingerprint = `${userAgent}-${timestamp}-${random}`;
    deviceId = btoa(fingerprint).substring(0, 32);

    // Store it
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}

/**
 * Get a human-readable device name
 * Used for display purposes in settings
 */
export function getDeviceName(): string {
  const ua = navigator.userAgent;

  // Detect OS
  let os = 'Unknown OS';
  if (ua.includes('Win')) os = 'Windows';
  else if (ua.includes('Mac')) os = 'macOS';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';

  // Detect Browser
  let browser = 'Unknown Browser';
  if (ua.includes('Firefox')) browser = 'Firefox';
  else if (ua.includes('Edg')) browser = 'Edge';
  else if (ua.includes('Chrome')) browser = 'Chrome';
  else if (ua.includes('Safari')) browser = 'Safari';

  return `${os} - ${browser}`;
}
